import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function usePlacementCohorts() {
  return useCbhFlag(CbhFeatureFlag.PLACEMENT_COHORTS, {
    defaultValue: {
      cohorts: [],
      flexReviewsInJobs: {
        enabled: false,
        windowStartDate: "2026-03-01",
        minFlexRatingsCountToShow: 0,
      },
    },
  });
}
